export const LABELS = {
  coreBasic: "CORE基礎編",
  coreActiveLearning: "CORE実践編",
  base: "BASE",
};

export const TEACHING_MATERIAL_KEYWORDS = {
  ORIENTATION: "オリエンテーション",
  MIDDLE: "中学",
  HIGH: "高校",
  CORE: "core",
  BASE: "base",
} as const;
